import { render, staticRenderFns } from "./mainsupplyremain.vue?vue&type=template&id=5b67dd75&scoped=true&"
import script from "./mainsupplyremain.vue?vue&type=script&lang=js&"
export * from "./mainsupplyremain.vue?vue&type=script&lang=js&"
import style0 from "./mainsupplyremain.vue?vue&type=style&index=0&id=5b67dd75&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b67dd75",
  null
  
)

export default component.exports